export default "/assets/site/images/vitorlas.jpg?b3acfec9ef48d773063d3f10b8136569";